<template>
  <div class="user-management-container">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <span class="header-title">{{
            $t("message.users.title")
          }}</span>
          <el-button v-if="canAddUser" type="primary" @click="handleAdd">{{
            $t("message.users.add")
          }}</el-button>
        </div>
      </template>
 
 
          <div class="right-content">
            <!-- Search Form -->
            <div class="search-area">
              <el-form :inline="true">
                
               <el-form-item :label="$t('message.organization.company')" prop="company_id">
                  
                  <el-tree-select
                    v-model="queryParams.companyId"
                    :props="treeProps"
                    :data="companyTreeOptions"
                    :load="loadTreeNode"
                    lazy
                    :placeholder="$t('message.users.selectCompany')"
                    check-strictly
                    clearable
                    filterable
                    style="width: 100%"
                    @node-click="handleNodeClick"
                    node-key="id"
                  />
                  
                </el-form-item>

                <el-form-item :label="$t('message.users.name')">
                  <el-input
                    v-model="queryParams.name"
                    :placeholder="$t('message.users.inputName')"
                    clearable
                    @clear="handleQuery"
                    @keyup.enter="handleQuery"
                    style="width: 200px"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleQuery">{{
                    $t("message.common.search")
                  }}</el-button>
                </el-form-item>
              </el-form>
            </div>

            <!-- Data Table -->
            <div class="table-wrapper">
              <el-table
                :data="usersList"
                border
                v-loading="loading"
                style="width: 100%"
              >
                <el-table-column
                  v-if="isColumnVisible"
                  prop="id"
                  :label="$t('message.users.id')"
                  width="80"
                />
                <el-table-column
                  prop="user_name"
                  :label="$t('message.users.name')"
                  width="160"
                  sortable
                />
  
                <el-table-column
                  prop="company_name"
                  :label="$t('message.users.organization')"
                  width="220"
                  sortable
                >
                </el-table-column>

                <el-table-column
                  prop="role_name"
                  :label="$t('message.users.role')"
                  width="150"
                  sortable
                >              
                </el-table-column>

                <el-table-column
                  prop="langType"
                  :label="$t('message.users.langType')"
                  width="150"
                  sortable
                >
                  <template #default="{ row }">
                    {{ getLangTypeLabel(row.langType) }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="creator"
                  :label="$t('message.users.creator')"
                  width="100"
                  sortable
                > 
                </el-table-column>

                <el-table-column
                  prop="created_at"
                  :label="$t('message.users.createdAt')"
                  width="200"
                  sortable
                >                 
                <template #default="{ row }">
                  {{ row?.created_at ? formatDateTime(row.created_at) : "--" }}
                </template>
                
                </el-table-column>

                <el-table-column
                  prop="state"
                  :label="$t('message.users.state')"
                  width="150"
                >
                  <template #default="{ row }">
                    <el-switch
                      v-model="row.state"
                      :active-value="1"
                      :inactive-value="0"                      
                      @change="handleStatusChange(row)"
                    />
                  </template>
                </el-table-column>                
                <el-table-column
                  :label="$t('message.users.actions')"
                  width="300"
                  fixed="right"
                >
                  <template #default="{ row }">
                    <el-button
                    v-if="canEditUser"
                      link
                      type="primary"
                      size="small"
                      @click="handleEditLang(row)"
                    >
                      {{ $t("message.users.editLang") }}
                    </el-button>

                    <el-button
                     v-if="canEditUser"
                      link
                      type="primary"
                      size="small"
                      @click="handleEditpwd(row)"
                    >
                      {{ $t("message.users.changePassword") }}
                    </el-button>
                    <el-button
                      v-if="canDeleteUser"
                      link
                      type="danger"
                      size="small"
                      @click="handleDelete(row)"
                      :disabled="isRootNode(row)"
                    >
                      {{ $t("message.common.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="pagination-container">
              <el-pagination
                v-model:current-page="queryParams.pageNum"
                v-model:page-size="queryParams.pageSize"
                :total="total"
                :page-sizes="[5, 10, 15, 20, 30]"
                :layout="'total, sizes, prev, pager, next, jumper'"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>      
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="dialogTitle"
      width="50%"
      @closed="resetForm"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        
        <el-form-item :label="$t('message.users.name')" label-width="140px" prop="name">
            <el-input
              v-model="formData.name"
              :placeholder="$t('message.users.inputName')"
              :disabled="dialogTitle === t('message.users.changePassword')" 
            />
        </el-form-item>

        <!-- 原密码（仅修改密码时显示） -->
        <el-form-item 
          v-if="dialogTitle === t('message.users.changePassword')"
          :label="$t('message.users.oldPassword')" 
          label-width="140px"
          prop="oldPassword"
        >
          <el-input
            v-model="formData.oldPassword"
            type="password"
            show-password
            :placeholder="$t('message.users.inputOldPassword')"
          />
        </el-form-item>

        <el-form-item :label=  "dialogTitle === t('message.users.add')? $t('message.users.password') : $t('message.users.newPassword')" label-width="140px" prop="password">
          <el-input
            v-model="formData.password"
            type="password"
            show-password
            :placeholder="dialogTitle === t('message.users.add')? $t('message.users.inputPassword') : $t('message.users.inputNewPassword')"
          />
        </el-form-item>

        <el-form-item :label="$t('message.users.confirmPassword')" label-width="140px" prop="confirmPassword">
          <el-input
            v-model="formData.confirmPassword"
            type="password"
            show-password
            :placeholder="$t('message.users.inputConfirmPassword')"
          />
        </el-form-item>

        <el-form-item          
          :label="$t('message.users.associatOrganization')"
          label-width="140px"
          prop="company_id"
          v-if="dialogTitle === t('message.users.add')"
        >
          <el-tree-select
            v-model="formData.company_id"
            :props="treeProps"
            :load="loadTreeNode"
            lazy
            :placeholder="$t('message.users.selectCompany')"
            check-strictly
            clearable
            filterable
            style="width: 100%"
            node-key="id"
          />

        </el-form-item>

        <el-form-item  v-if="dialogTitle === t('message.users.add')" :label="$t('message.users.langType')" label-width="140px" prop="langType">
                <el-select 
                  v-model="formData.langType" 
                  :placeholder="$t('message.users.langTypeRequired')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in langTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
         </el-form-item>

        <el-form-item  v-if="dialogTitle === t('message.users.add')" :label="$t('message.users.associatRole')" label-width="140px" prop="role_id">
                <el-select 
                  v-model="formData.role_id" 
                  :placeholder="$t('message.users.roleRequired')"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
         </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">{{
              $t("message.common.cancel")
          }}</el-button>
          <el-button type="primary" @click="submitForm">{{
            $t("message.common.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
      <!-- 编辑语言对话框 -->
  <el-dialog
    v-model="langDialogVisible"
    :title="$t('message.users.editLang')"
    width="400px"
    @closed="resetLangForm"
  >
    <el-form
      ref="langFormRef"
      :model="langFormData"
      :rules="langRules"
      label-width="120px"
    >
      <el-form-item :label="$t('message.users.name')" prop="user_name">
        <el-input v-model="langFormData.user_name" disabled />
      </el-form-item>

      <el-form-item :label="$t('message.users.langType')" prop="langType">
        <el-select 
          v-model="langFormData.langType" 
          :placeholder="$t('message.users.langTypeRequired')"
          style="width: 100%"
        >
          <el-option
            v-for="item in langTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="langDialogVisible = false">{{
          $t("message.common.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitLangForm">{{
          $t("message.common.confirm")
        }}</el-button>
      </span>
    </template>
  </el-dialog>

  </div>


</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import {getCompanyTree} from "@/api/CompanyManager";

import {
  getUserList,  
  getUserAdd,
  getUserPasswordEdit,
  getUserDelete,
  getUserDisable,
  hanldChangeUserlang,
  fetchUserOptions,
} from "@/api/UserManager";

import { usePermission } from '@/composables/usePermission'

const {  canAddUser,canEditUser,canDeleteUser } = usePermission()

const { t } = useI18n();
// Tree structure data
const treeData = ref([]);
const companyTreeOptions = ref([]); // 添加企业树数据
 
// Query parameters
const queryParams = ref({
  pageNum: 1,
  pageSize: 10,
  name: "",
  companyId: null,
});


// Table data
const usersList = ref([]);

const loading = ref(false);
const total = ref(3);
//const jumperPage = ref(1)
// 对话框控制
const dialogVisible = ref(false);
const dialogTitle = ref("");
const companyTreeData = ref([]);
const formRef = ref();
 
// 树形配置
const treeProps = {
  value: "id",
  label: "name",
  children: "children",
};



// 表单数据
const formData = reactive({
  id: 0,
  name: "",
  oldPassword: "", 
  password:"",
  confirmPassword:"",
  company_id: 0,
  role_id: 0,  
  langType:2,
});
  
        
// 表单验证规则
const rules = reactive({
  name: [
    {
      required: true,
      message: t("message.users.nameRequired"),
      trigger: "blur",
    },
  ],
  oldPassword: [
    { required: true, message: t("message.users.oldPasswordRequired"), trigger: "blur" }
  ],
  password: [
    {
      required: true,
      message: t("message.users.passwordRequired"),
      trigger: "blur",
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: t("message.users.confirmPasswordRequired"),
      trigger: "blur",
    },
  ],
  company_id: [
    {
      required: true,
      message: t("message.users.companyRequired"),
      trigger: "blur",
    },
  ],  
  role_id: [
    {
      required: true,
      message: t("message.users.roleRequired"),
      trigger: "blur",
    },
  ],
  langType: [
    {
      required: true,
      message: t("message.users.langTypeRequired"),
      trigger: "blur",
    },
  ],
});

const roleOptions = ref([]);
const langTypeOptions = ref([]);
const loadOptions = () => { 
  roleOptions.value = [
/*  { value: 1, label: '超级管理员' },
   { value: 2, label: '管理员' },
  { value: 3, label: '监控员' } */
  ]

  langTypeOptions.value=[
    {value:1,label:'Chinese'},
    {value:2,label:'English'},
  ]
};


// ===== 编辑语言相关 =====
const langDialogVisible = ref(false);
const langFormRef = ref();
const langFormData = reactive({
  id: 0,
  user_name: '',
  langType: 2,
});

const langRules = reactive({
  langType: [
    {
      required: true,
      message: t("message.users.langTypeRequired"),
      trigger: "blur",
    },
  ],
});

const handleEditLang = (row) => {
  langDialogVisible.value = true;
  langFormData.id = row.id;
  langFormData.user_name = row.user_name;
  langFormData.langType = row.langType || 2;
};

const resetLangForm = () => {
  langFormData.id = 0;
  langFormData.user_name = '';
  langFormData.langType = 2;
  langFormRef.value?.clearValidate();
};

const submitLangForm = async () => {
  try {
    await langFormRef.value?.validate();

    const requestData = {
      UserId: langFormData.id,
      LangType: langFormData.langType,
    };

    const ret = await hanldChangeUserlang(requestData);

    if (ret.success) {
      ElMessage.success(t("message.users.langUpdateSuccess"));
      langDialogVisible.value = false;
      await fetchData();
    } else {
      ElMessage.error(ret?.msg || t("message.users.langUpdateFailed"));
    }
  } catch (error) {
    console.error("修改语言失败:", error);
    ElMessage.error(error.message || t("message.users.operationFailed"));
  }
};


const fetchData = async () => {
  loading.value = true;
  try {
    // 创建干净的请求参数对象，移除空值
    const params = {
      pageNum: queryParams.value.pageNum,
      pageSize: queryParams.value.pageSize,
      ...(queryParams.value.name && { name: queryParams.value.name }), // 只有name有值时才包含
      ...(queryParams.value.companyId && {
        companyId: queryParams.value.companyId,
      }), // 只有companyId有值时才包含
    };
    await loadUserList(params);
  } catch (error) {
    ElMessage.error(t("message.common.fetchError"));
  } finally {
    loading.value = false;
  }
};

 

// 判断是否是根节点的方法
const isRootNode = (node) => {
  return node.isCurrentUser === true;
};

// 在 loadCompanyTree 函数中，添加错误处理
const loadCompanyTree = async () => {
  try {
    loading.value = true;
 
    
    const params = {isGetChild:false}
    const res = await getCompanyTree({params});

    if (res?.success) {
      companyTreeData.value = res.data.list;
      treeData.value = transformTreeData(res.data.list || []);
      if ( res.data.list.length > 0) {
        formData.company_id =  res.data.list[0].id;
        queryParams.value.companyId = res.data.list[0].id
        await fetchData();
      }
    } else {
      ElMessage.error(res?.msg || t("message.gateway.loadCompanyFailed"));
    }
    
  } catch (error) {
    console.error("加载企业树失败:", error);
    ElMessage.error(t("message.gateway.loadCompanyFailed"));
  } finally {
    loading.value = false;
  }
};

const loadUserList = async (params = {}) => {
    try {
        //企业列表
        const resList = await getUserList(params);
        if (resList?.success) {
          usersList.value = resList.data.list;
          total.value = resList.data.totalCount;
        } else {
          ElMessage.warning(resList?.msg || t("message.users.loadListFailed"));
        }
    } catch (error) {
      console.error("加载企业树失败:", error);
      ElMessage.error(t("message.users.loadListFailed"));
    } finally {
      loading.value = false;
    }
};

 
const loadTreeNode = async (node, resolve) => {
  try {
    await new Promise(resolve => setTimeout(resolve, 50)); 
    // 首次加载根节点（level=0）
    if (node.level === 0) {
      resolve(companyTreeOptions.value);
      return;

      /* const res = await getCompanyTree({ 
        isGetChild: false
      });
      const rootNodes = transformTreeData(res.data.list || []);
      formData.company_id = node.data.id
      resolve(rootNodes);
      return; */
    }

    // 加载子节点
    const res = await getCompanyTree({
      isGetChild: false,
      companyId: node.data.id
    });
    
    const childNodes = transformTreeData(res.data.list || []);
    resolve(childNodes);

  } catch (error) {
    console.error('加载企业树失败:', error);
    resolve([]);
  }
}  
 

// Transform API data to tree structure
const transformTreeData = (apiData) => {
  return apiData.map((item) => ({
    id: item.id,
    label: item.name, // Or use t() if you need translation
     name: item.name,
    parent_id: item.parent_id,
    level: item.level,
    order_num: item.order_num,
    contact: item.contact,
    phone: item.phone,
    location: item.location,
    created_at: item.created_at,
    children: item.children ? transformTreeData(item.children) : [],
  }));
};
 
// Helper function to format date
const formatDateTime = (dateString) => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);
    return date
      .toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(/\//g, "-");
  } catch {
    return dateString;
  }
};

// 语言类型映射
const langTypeMap = {
  1: 'Chinese',
  2: 'English'
};

// 获取语言类型标签
const getLangTypeLabel = (value) => {
  if (value === undefined || value === null) {
    return '--';
  }
  const numValue = Number(value);
  return langTypeMap[numValue] || '--';
};

const handleStatusChange =async(row) => {

  if(row.state ===0)
  {
    await ElMessageBox.confirm(
        t("message.users.DisableConfirm", { name: row.user_name }),
        t("message.common.warning"),
        {
          confirmButtonText: t("message.common.confirm"),
          cancelButtonText: t("message.common.cancel"),
          type: "warning",
        }
      );
  }
  
    const requestData = {
        id: row.id,
        state:row.state
      };
   const ret =  await getUserDisable(requestData);  
   if(ret.success)
   {
     // formData.state = 1
   }
   else
   {
      ElMessage.error(ret?.msg);         
   }
}

const handleNodeClick =async (nodeData) => {
  
  
  // 实际业务逻辑示例：
  // 1. 加载该节点对应的数据
  //loadNodeData(nodeData.id)
  
  // 2. 更新查询参数 // 根据选中节点刷新右侧表格数据
  queryParams.value.companyId = nodeData.id
  fetchData()

}

const handleQuery = () => {
  fetchData();
};

const handleSizeChange = (val) => {
  queryParams.value.pageNum = 1;
  queryParams.value.pageSize = val;
  fetchData();
};

const handleCurrentChange = (val) => {
  queryParams.value.pageNum = val;
  fetchData();
};

//增加用户
const handleAdd = () => {
  dialogTitle.value = t("message.users.add");
  formData.id = 0;
  formData.name = '';
  formData.oldPassword = '';
  formData.password = '';        
  formData.confirmPassword = '';
  formData.langType = 2;
   if (companyTreeData.value.length > 0) {
    formData.company_id = companyTreeData.value[0].id;
  } 
  formData.isRootNode = 0;
  dialogVisible.value = true;
};
//修改密码
const handleEditpwd = (row) => {
  dialogTitle.value = t("message.users.changePassword");
    Object.assign(formData, {
    id: row.id,
    name: row.user_name, // 显示用户名
    oldPassword: "", // 清空原密码输入框
    password: "", // 清空新密码输入框
    confirmPassword: "" // 清空确认密码输入框
  });

    // formData.id = row.id;
    // formData.name =  row.user_name;    
    // formData.oldPassword = "";
    // formData.password = "";
    // formData.confirmPassword = "";
 
  dialogVisible.value = true;
};

const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(
      t("message.users.deleteConfirm", { name: row.user_name }),
      t("message.common.warning"),
      {
        confirmButtonText: t("message.common.confirm"),
        cancelButtonText: t("message.common.cancel"),
        type: "warning",
      }
    );

    // 用户确认删除
    loading.value = true;
     const requestData = {
        id: row.id 
      };

    const ret = await getUserDelete(requestData);

    if (ret.success) {
      ElMessage.success(t("message.users.deleteSuccess"));
      await loadCompanyTree(); // 刷新数据
    } else {
      ElMessage.error(ret?.msg || t("message.users.deleteFailed"));
    }
  } catch (error) {
    // 区分用户取消和真实错误
    if (error !== "cancel") {
      console.error("删除企业失败:", error);
      ElMessage.error(t("message.users.operationFailed"));
    }
    // 用户点击取消不做任何处理
  } finally {
    loading.value = false;
  }
};

const submitForm = async () => {
  try {
    await formRef.value?.validate();

    if (formData.id) {
      if(formData.password===null || formData.password.trim ==="")
      {
          ElMessage.success(t("message.users.passwordNull"));        
          return;
      }
      
      if(formData.password != formData.confirmPassword)
      {
          ElMessage.success(t("message.users.passwordNotMatch"));  
          return 
      }
      const requestData = {
        UserId: formData.id,
        UserName: formData.name,
        OldPassword:formData.oldPassword,
        NewPassword: formData.password,        
        ConfirmPassword: formData.confirmPassword,
        langType:formData.langType
      };


      const ret = await getUserPasswordEdit(requestData);
      if (ret.success) {
        ElMessage.success(t("message.users.updateSuccess"));
      }
      else
      {
        ElMessage.success(ret?.msg ||  t("message.users.updateFailed"));
      }
    } 
    else
    {
        if(formData.password===null || formData.password.trim ==="")
        {
            ElMessage.success(t("message.users.passwordNull"));        
            return;
        }

        if(formData.password!=formData.confirmPassword)
        {
          ElMessage.success(t("message.users.passwordNotMatch"));        
          return  ;
        }
        const requestData = {                           
                              user_name: formData.name,
                              password: formData.password,
                              confirmPassword: formData.confirmPassword,
                              // 如果是根节点，不传parent_id或传0
                              company_id: formData.company_id,                                                        
                              role_id: formData.role_id,
                              langType: formData.langType,
                            };

        const ret = await getUserAdd(requestData);
        if (ret.success) {
          ElMessage.success(t("message.users.addSuccess"));
           formData.name = '';
           formData.oldPassword = '';
           formData.password = '';        
           formData.confirmPassword = '';
        } else {
          ElMessage.success(ret?.msg || t("message.users.addFailed"));
        }
    }

    dialogVisible.value = false;
    await loadCompanyTree();
  } catch (error) {
    console.error("表单提交失败:", error);
    ElMessage.error(error.message || t("message.users.operationFailed") + error);
  }
};


// 初始化加载数据
const initData = async () => {
  try {
    loading.value = true;
    // 并行加载企业树
    await Promise.all([
      loadCompanyTreeInit(),
      fetchData()
    ]);
  } catch (error) {
    ElMessage.error(error || t("message.common.fetchError"));
  } finally {
    loading.value = false;
  }
};

// 加载企业树数据
const loadCompanyTreeInit = async () => {
  try {
    const res = await getCompanyTree({ 
      isGetChild: false
    });
    if (res?.success) {
      companyTreeOptions.value = transformTreeData(res.data.list || []);      
      formData.company_id =  companyTreeOptions.value[0].id;
      queryParams.value.companyId=  companyTreeOptions.value[0].id;      
    } else {
      ElMessage.warning(res?.msg || t("message.common.loadFailed"));
    }
  } catch (error) {
    console.error('加载企业树失败:', error);
    ElMessage.error(t("message.common.loadFailed"));
  }
};


onMounted(async () => {
  
  await initData();
   
      loadOptions();
      const retuserOptions = await fetchUserOptions()        
      roleOptions.value = retuserOptions.roleOptions.list.map(item => ({
        value: item.id,
        label: item.name
      }))

      if(roleOptions.value.length>0)
      {
          formData.role_id = roleOptions.value[0].value;
      }
      

});
</script>

<style scoped lang="scss">
.user-management-container {
  padding: 20px;

  .el-row {
    display: flex;
    align-items: stretch; // 关键属性，让子项高度相同

    .el-col {
      display: flex;
      flex-direction: column;

      .tree-container,
      .right-content {
        flex: 1; // 填充剩余空间
        height: 100%; // 确保高度100%
      }
    }
  }

  .box-card {
    border-radius: 4px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .equal-height-row {
    display: flex;
    align-items: stretch; // 确保列高度相同
    height: 800px; //calc(100vh - 180px); // 根据实际布局调整，减去的值=顶部高度+卡片边距等

    .equal-height-col {
      display: flex;
      flex-direction: column;
      height: 100%;

      .tree-container,
      .right-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden; // 禁止外部容器滚动
      }
    }
  }

  .tree-container {
    // 保持原有样式
    padding: 15px;
    background-color: #fff;  // #f5f7fa;
    border-radius: 4px;
    height: 100%;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    // 新增滚动相关样式
    display: flex;
    flex-direction: column;
    overflow: hidden; // 隐藏内部溢出

    .tree-title {
      margin-top: 0;
      margin-bottom: 15px;
      font-size: 14px;
      color: #606266;
      flex-shrink: 0; // 防止标题被压缩
    }

    // 树容器滚动区域
    .tree-scroll-wrapper {
      flex: 1;
      overflow: auto; // 自动显示滚动条
      min-height: 200px; // 最小高度保证

      // 自定义滚动条样式 (Webkit浏览器)
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
        &:hover {
          background-color: #a8a8a8;
        }
      }
      &::-webkit-scrollbar-track {
        background-color: #f1f1f1;
        border-radius: 4px;
      }
    }

    :deep(.el-tree) {
      background-color: transparent;
      min-width: 100%; // 保证树的最小宽度
      width: max-content; // 根据内容自动扩展宽度

      .tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
        min-width: 100%; // 节点最小宽度
        
          &.is-current {
            > .el-tree-node__content {
              background-color: #f0f7ff;
              .tree-node-label {
                color: #409eff;
                font-weight: 500;
              }
            }
          }
        .node-actions {
          visibility: hidden;
        }

        &:hover .node-actions {
          visibility: visible;
        }
      }
    }
  }

  .right-content {
    padding-left: 0;
    margin-left: -10px;
    border: 1px solid #ebeef5; // 添加边框线
    border-radius: 4px; // 圆角
    padding: 15px; // 增加内边距
    background-color: #fff; // 白色背景
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); // 可选：添加阴影

    .search-area {
      margin-bottom: 20px;

      :deep(.el-form-item) {
        margin-bottom: 0;
      }
    }

    .table-wrapper {
      width: 100%;
      margin-bottom: 20px;
      flex: 1;
      overflow-y: auto; // 表格区域单独滚动

      :deep(.el-table) {
        width: 100% !important;
        border: 1px solid #ebeef5; // 表格外边框
        border-radius: 4px; // 圆角

        th,
        td {
          border-right: 1px solid #ebeef5; // 单元格右边框
          border-bottom: 1px solid #ebeef5; // 单元格下边框
        }
      }
    }

    .search-area,
    .pagination-container {
      flex-shrink: 0; // 防止搜索和分页被压缩
    }
  }

  .pagination-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
/* 添加禁用状态的样式 */
.node-actions-disabled {
  opacity: 0.5;
  cursor: not-allowed;

  .el-button {
    color: #c0c4cc !important;
  }
}
</style>
